export * from "./DynamicComponent";
